export * from "./DynamicComponent";
